import { categoryAbrvs } from "@utils/account-settings/my-limits/getCategoryAbrv";
import { isGamesTheme } from "@utils/common/theme";

export function filterAndMapLimitCategoriesByTheme<
	T extends { gamingLimitCategory: { abrv: string } },
>(limitCategories: T[]) {
	return limitCategories
		.filter((category) => {
			if (isGamesTheme()) {
				const isOnlineCasino =
					category.gamingLimitCategory.abrv ===
					categoryAbrvs.games.loss;
				const isGamesDeposit =
					category.gamingLimitCategory.abrv ===
					categoryAbrvs.games.deposit;
				return isOnlineCasino || isGamesDeposit;
			}

			return true;
		})
		.map((category) => {
			if (
				(isGamesTheme() || WEBPACK_IS_GAMES_ENABLED) &&
				category.gamingLimitCategory.abrv === "online-casino"
			) {
				return {
					...category,
					gamingLimitCategory: {
						...category.gamingLimitCategory,
						name: "HEADER.GAMES",
					},
				};
			}
			return category;
		});
}
